import React from "react";
import { Table } from "react-bootstrap";

interface SwapsSummaryTableProps {
  swaps: any[];
}

const SwapsSummaryTable: React.FC<SwapsSummaryTableProps> = ({ swaps }) => (
  <Table striped bordered size="sm" className="mb-3">
    <thead>
      <tr>
        <th>Original</th>
        <th></th>
        <th>Nuevo</th>
        <th>Cantidad</th>
      </tr>
    </thead>
    <tbody>
      {swaps.map((swap, idx) => (
        <tr key={idx} style={{ background: "#f8f9fa" }}>
          <td>{swap.originalProductDescription}</td>
          <td style={{ textAlign: "center", fontSize: 18 }}>→</td>
          <td>{swap.newProductDescription}</td>
          <td style={{ textAlign: "center" }}>{swap.quantity}</td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default SwapsSummaryTable;
